import { useEffect, useState } from 'react';

export const usePeripheralsHeight = (root: HTMLElement | null) => {
  const [peripheralsHeight, setPeripheralsHeight] = useState(0);

  useEffect(() => {
    if (!root) {
      return;
    }
    const elements = root.querySelectorAll('[data-peripheral]');

    const observer = new ResizeObserver(() => {
      let height = 0;
      elements.forEach((el) => {
        height += el.getBoundingClientRect().height;
      });
      setPeripheralsHeight(height);
    });
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [root]);

  return peripheralsHeight;
};
